<template>
  <div class="flat-card-tags">
    <div
      v-if="status == 'booked'"
      class="flats-list__tag--booked btn btn-tag btn-tag-default"
    >
      <Icon icon="lock2" />{{ $filters.bookedStatusNormalize(layout) }}
    </div>
    <!-- <div
      v-if="discount"
      class="flat-card-tags__tag--discount btn btn-tag btn-tag-red"
    >
      <span>{{ discount }}%</span> скидка
    </div> -->
    <div v-if="tag" class="flat-card-tags__tag--balcony btn-tag-balcony">
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_3336_311)">
          <path
            d="M13.6693 2H13.3359V1.33333C13.3359 0.979711 13.1955 0.640573 12.9454 0.390524C12.6954 0.140476 12.3562 0 12.0026 0H2.66927C2.31565 0 1.97651 0.140476 1.72646 0.390524C1.47641 0.640573 1.33594 0.979711 1.33594 1.33333V3.33333C1.33594 3.68696 1.47641 4.02609 1.72646 4.27614C1.97651 4.52619 2.31565 4.66667 2.66927 4.66667H12.0026C12.3562 4.66667 12.6954 4.52619 12.9454 4.27614C13.1955 4.02609 13.3359 3.68696 13.3359 3.33333V2.66667H13.6693C13.7577 2.66667 13.8425 2.70179 13.905 2.7643C13.9675 2.82681 14.0026 2.91159 14.0026 3V6.33333C14.0026 6.42174 13.9675 6.50652 13.905 6.56904C13.8425 6.63155 13.7577 6.66667 13.6693 6.66667H8.0026C7.73739 6.66667 7.48303 6.77202 7.2955 6.95956C7.10796 7.1471 7.0026 7.40145 7.0026 7.66667V8.50333C6.69161 8.7433 6.43977 9.05136 6.26642 9.40384C6.09306 9.75633 6.00281 10.1439 6.0026 10.5367V14C6.0026 14.2652 6.10796 14.5196 6.2955 14.7071C6.48303 14.8946 6.73739 15 7.0026 15H7.66927C7.93449 15 8.18884 14.8946 8.37638 14.7071C8.56391 14.5196 8.66927 14.2652 8.66927 14V10.5367C8.66906 10.1439 8.57881 9.75633 8.40546 9.40384C8.23211 9.05136 7.98026 8.7433 7.66927 8.50333V7.66667C7.66927 7.57826 7.70439 7.49348 7.7669 7.43096C7.82941 7.36845 7.9142 7.33333 8.0026 7.33333H13.6693C13.9345 7.33333 14.1888 7.22798 14.3764 7.04044C14.5639 6.8529 14.6693 6.59855 14.6693 6.33333V3C14.6693 2.73478 14.5639 2.48043 14.3764 2.29289C14.1888 2.10536 13.9345 2 13.6693 2ZM12.6693 3.33333C12.6693 3.51014 12.599 3.67971 12.474 3.80474C12.349 3.92976 12.1794 4 12.0026 4H2.66927C2.49246 4 2.32289 3.92976 2.19787 3.80474C2.07284 3.67971 2.0026 3.51014 2.0026 3.33333V1.33333C2.0026 1.15652 2.07284 0.986953 2.19787 0.861929C2.32289 0.736905 2.49246 0.666667 2.66927 0.666667H12.0026C12.1794 0.666667 12.349 0.736905 12.474 0.861929C12.599 0.986953 12.6693 1.15652 12.6693 1.33333V3.33333ZM8.0026 10.5367V14C8.0026 14.0884 7.96749 14.1732 7.90497 14.2357C7.84246 14.2982 7.75768 14.3333 7.66927 14.3333H7.0026C6.9142 14.3333 6.82941 14.2982 6.7669 14.2357C6.70439 14.1732 6.66927 14.0884 6.66927 14V10.5367C6.669 10.2607 6.72844 9.98788 6.84351 9.73702C6.95859 9.48616 7.12657 9.26316 7.33594 9.08333C7.54531 9.26316 7.71329 9.48616 7.82836 9.73702C7.94344 9.98788 8.00288 10.2607 8.0026 10.5367Z"
            fill="#FF0020"
            stroke="#FF0020"
            stroke-width="0.3"
          />
        </g>
        <defs>
          <clipPath id="clip0_3336_311">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>

      Наличие балкона
    </div>
    <div v-if="tagPayment" class="flats-card__tag btn btn-tag btn-tag-red">
      Без первого взноса
    </div>
    <div
      v-if="data?.properties?.castom_sticker_2"
      class="flats-card__tag btn btn-tag btn-tag-red"
      v-html="data?.properties?.castom_sticker_2"
    />
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: "",
    },
    layout: {
      type: String,
      default: "",
    },
    tag: {
      type: Boolean,
      default: false,
    },
    tagPayment: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss">
.flat-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  &__tag {
    gap: 8px;
    &--booked {
    }
  }
}
</style>
